module.exports = __webpack_public_path__ + "img/image21.fd5dd246.png";